<form [formGroup]="form">
  <div class="inputs-layout">
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Identificador</mat-label>
      <input formControlName="id" matInput>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Descripción</mat-label>
      <input formControlName="text" matInput>
    </mat-form-field>
    <mat-form-field *ngIf="form.get('categorias').enabled" appearance="outline" class="inputs-layout__input">
      <mat-label>Categoría</mat-label>
      <mat-select formControlName="categorias" multiple>
        <mat-option *ngFor="let element of categorias" [value]="element.ordenAgrupador">{{element.nombre}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Subcategoría</mat-label>
      <mat-select formControlName="subCategorias" multiple>
        <mat-option *ngFor="let element of subCategorias" [value]="element.id">{{element.nombre}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Materias</mat-label>
      <mat-select formControlName="materias" multiple>
        <mat-optgroup *ngFor="let area of materias" [label]="area.nombre">
          <mat-option *ngFor="let materia of area.materias" [value]="materia.id">
            {{materia.nombre}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Grados</mat-label>
      <mat-select formControlName="grados" multiple>
        <mat-option *ngFor="let curso of grados" [value]="curso.id">{{curso.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Ámbitos</mat-label>
      <mat-select formControlName="ambitos" multiple>
        <mat-optgroup *ngFor="let ambito of ambitos" [label]="ambito.nombre">
          <mat-option *ngFor="let categoria of ambito.categorias" [value]="categoria.id">
            {{categoria.nombre}}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="inputs-layout__input">
      <mat-label>Tags</mat-label>
      <mat-select formControlName="tags" multiple>
        <mat-option *ngFor="let tag of tags" [value]="tag.id">{{tag.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>